<template>
  <div
    class="x-layout-max-width-md x-layout-item desktop:x-layout-min-margin-32 large:x-layout-max-width-lg large:x-layout-min-margin-48"
  >
    <slot />
  </div>
</template>

<script setup lang="ts"></script>
<style scoped lang="scss"></style>
